/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { listChanceCosts } from '../../../modules/chanceModule/chanceCosts';
import ProductCostList from '../../../components/chancemng/costcalc/ProductCostList';

const CostCalcLockListContainer = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { chance, productCosts, error, loading } = useSelector(
    ({ chanceModule, loading }) => ({
      chance: chanceModule.chance.chance,
      productCosts: chanceModule.chanceCosts.costs,
      error: chanceModule.chanceCosts.error,
      loading: loading['chance/LIST_CHANCE_COSTS'],
    }),
  );

  useEffect(() => {
    if (chance) {
      dispatch(listChanceCosts(chance.prjUuid));
    }
    //언마운트될때 리덕스에서 파트너 데이터 초기화
    // return () => {
    //   dispatch(unloadCosts());
    // };
  }, [dispatch, chance]);

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'expUuid',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'prjUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'productUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'priceUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'sellPartnerNm',
        headerName: '매입처',
        type: 'string',
        minWidth: 150,
        flex: 0.7,
        editable: false,
        sortable: false,
      },
      {
        field: 'partnerNm',
        headerName: '제조사',
        type: 'string',
        minWidth: 150,
        flex: 0.7,
        editable: false,
        sortable: false,
      },
      {
        field: 'productNm',
        headerName: '제품명',
        type: 'string',
        minWidth: 200,
        flex: 1,
        editable: false,
        sortable: false,
      },

      {
        field: 'expCnt',
        headerName: '수량',
        minWidth: 80,
        flex: 0.4,
        type: 'number',
        editable: false,
        valueFormatter: (params) => {
          const valueFormatted = Number(params.value).toLocaleString('ko-KR');
          return `${valueFormatted}`;
        },
      },
      {
        field: 'unitVal',
        headerName: '매출단가',
        minWidth: 100,
        flex: 0.5,
        type: 'number',
        editable: false,
        renderCell: (params) => {
          const value =
            params.value !== null && params.value !== undefined
              ? params.value
              : 0;
          const valueFormatted = Number(value).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
      },
      {
        field: 'priceVal',
        headerName: '매입단가',
        minWidth: 100,
        flex: 0.5,
        type: 'number',
        editable: false,
        valueFormatter: (params) => {
          const valueFormatted = Number(params.value).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
      },
      {
        field: 'saleVal',
        headerName: '매출액',
        minWidth: 100,
        flex: 0.5,
        type: 'number',
        editable: false,
        valueFormatter: (params) => {
          const valueFormatted = Number(params.value).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
      },
      {
        field: 'buyVal',
        headerName: '매입액',
        minWidth: 100,
        flex: 0.5,
        type: 'number',
        valueFormatter: (params) => {
          const valueFormatted = Number(params.value).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
        editable: false,
      },
      {
        field: 'saleProfit',
        headerName: '매출이익',
        minWidth: 100,
        flex: 0.5,
        type: 'number',
        editable: false,
        renderCell: (params) => {
          const value =
            params.value !== null && params.value !== undefined
              ? params.value
              : 0;
          const valueFormatted = Number(value).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
      },
      {
        field: 'salePct',
        headerName: '이익율',
        minWidth: 80,
        flex: 0.4,
        type: 'number',
        editable: false,
        renderCell: (params) => {
          return params.value + '%';
        },
      },
      {
        field: 'mntDt',
        headerName: '유지보수기간(개월)',
        minWidth: 120,
        flex: 0.6,
        type: 'number',
        editable: false,
        renderCell: (params) => {
          return params.value + '개월';
        },
      },
      {
        field: 'mntStDt',
        headerName: '유지보수시작일',
        minWidth: 120,
        flex: 0.6,
        type: 'date',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
    ],
    [],
  );

  return (
    <>
      <ProductCostList
        columns={columns}
        productCosts={productCosts}
        error={error}
        loading={loading}
                
        columnVisibilityModel={{
          id: false,
          productUuid: false,
          prjUuid: false,
          expUuid: false,
        }}
      />
    </>
  );
};

export default CostCalcLockListContainer;
